module.exports = __webpack_public_path__ + "static/media/h.90ae3e1e.svg";